import React, { useState } from "react";
import { LoginApi } from "../api/Users";
import Swal from "sweetalert2";
import { useCookies } from "react-cookie";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
  const [cookies, setCookie, removeCookie] = useCookies([
    "token",
    "user",
    "id",
  ]);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (cookies.token) {
      navigate("/");
    }
  }, [cookies.token, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const response = LoginApi({
      email: email,
      password: password,
    });
    response
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          Swal.fire({
            title: "Login Successful!",
            text: "You have successfully logged in!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          setEmail("");
          setPassword("");
          setCookie("token", res?.token);
          setCookie("user", res?.user?.name);
          setCookie("id", res?.user?.id);
          setCookie("admin", res?.isAdmin || false);
        }
      })
      .catch((err) => {
        setError(err.message);
        console.log(err);
      });
    setError("");
  };

  return (
    <>
      <section id="register" className="py-5">
        <div className="container">
          <h1 className="text-center">Login form</h1>
          <div className="row justify-content-center align-items-center">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <img
                src="/assets/images/register-bg.jpg"
                alt="logo"
                width="100%"
              />
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputPassword1">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </form>
              <div className="text-left pt-3">
                <Link
                  to="/register"
                  className="text-dark"
                  style={{ fontSize: 18 }}
                >
                  Register Now!
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
